import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {FILTER_BAR_MODULE} from "../filter-bar-module.consts";

export class FilterBarModuleToggleClickEvent extends ClickEvent {
  toggleType: FILTER_BAR_MODULE.ANALYTICS.TOGGLE_TYPES;
  clickType: Number;

  constructor(params: FilterBarModuleToggleClickEvent) {
    super('', 'click', 'scores-list-toggle');

    this.toggleType = params.toggleType;
    this.clickType = params.clickType;
  }

  get properties() {
    const properties = super.properties;

    properties.toggleType = this.toggleType;
    properties.clickType = this.clickType;

    return properties;
  }

}
